import {UserInputValue} from '@mintdata/mint-kit/api/properties/PropertyEditorPart';
import {action, observable} from 'mobx';

export class EditorPartState<T>
{
    @observable
    public pendingValue:T = null;

    @observable
    public userInput:UserInputValue = null;

    @observable
    public isValid:boolean = true;

    @observable
    public validationError:string = null;

    @observable
    public isSelected:boolean = false;

    @observable
    public isFocused:boolean = false;

    @observable
    public isChanged:boolean = false;

    @observable
    public isConfirmed:boolean = true;

    @action.bound
    public setPendingValue(pendingValue:any):void
    {
        this.pendingValue = pendingValue;
    }

    @action.bound
    public setUserInput(userInput:UserInputValue):void
    {
        this.userInput = userInput;
    }

    @action.bound
    public setIsValid(isValid:boolean):void
    {
        this.isValid = isValid;
    }

    @action.bound
    public setValidationError(validationError:string):void
    {
        this.validationError = validationError;
    }

    @action.bound
    public setIsSelected(isSelected:boolean):void
    {
        this.isSelected = isSelected;
    }

    @action.bound
    public setIsFocused(isFocused:boolean):void
    {
        this.isFocused = isFocused;
    }

    @action.bound
    public setIsChanged(isChanged:boolean):void
    {
        this.isChanged = isChanged;
    }

    @action.bound
    public setIsConfirmed(isConfirmed:boolean):void
    {
        this.isConfirmed = isConfirmed;
    }

    @action.bound
    public clear():void {
        this.setPendingValue(null);
        this.setUserInput(null);
        this.setValidationError(null);
        this.setIsValid(true);
        this.setIsChanged(false);
        this.setIsConfirmed(true);
    }
}
